import PropTypes from "prop-types";
import React from "react";

const Waveform = ({ meterBars, listening }) => (
  <div className="waveform-container-v2">
    {meterBars.map((height, index) => (
      <div
        key={index}
        className={`waveform-bar-v2 ${listening ? "active_" : ""}`}
        style={{
          height: listening ? `${height}px` : "8px",
          animationDelay: `${index * 0.03}s`,
        }}
      ></div>
    ))}
  </div>
);

Waveform.propTypes = {
  listening: PropTypes.bool.isRequired,
  meterBars: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default Waveform;

